import React, { useEffect, useState } from "react";
import "../Portfoliooo/Portfolio.css";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import dawood from "../image/dawoodimage.png";
import progamer from "../image/progemer.png";
import task1 from "../image/task1.png";
import vivadecor from "../image/vivadecor.png";
import tpdolist from "../image/tpdolist.png";
import Weather from "../image/Weather.png";
import Ecommerce from "../image/E-commerce.png";
import islamyat from "../image/islamyat.png";
import Calculateage from "../image/Calculateage.png";
import { MdOutlineVisibility } from "react-icons/md";
import { IoLogoGithub } from "react-icons/io";


function Portfolio() {
  
  useEffect(() => {
    const number = document.querySelector('.number');
    const boxpro = document.querySelectorAll('.boxpro');
    const prev = document.querySelector('.prev');
    const next = document.querySelector('.next');
    const length = boxpro.length;
    let slider = 1;
  
    if (number.innerHTML === '') {
      for (let i = 1; i <= length; i++) {
        const pnumber = document.createElement('p');
        const textNode = document.createTextNode(i);
        pnumber.setAttribute('data-index', i);
        pnumber.appendChild(textNode);
        number.appendChild(pnumber);
  
        // Add click event listener to each pnumber
        pnumber.addEventListener('click', () => {
          slider = parseInt(pnumber.getAttribute('data-index'));
          sheck(); // Call sheck to update slider position
        });
      }
    }
  
    const sheck = () => {
      // Update prev and next button classes
      if (slider === 1) {
        prev.classList.add('active');
      } else {
        prev.classList.remove('active');
      }
  
      if (slider === length) {
        next.classList.add('active');
      } else {
        next.classList.remove('active');
      }
  
      // Update active classes for boxpro and number indicators
      if (boxpro.length > 0) {
        for (let i = 0; i < boxpro.length; i++) {
          boxpro[i].classList.remove('active');
          number.children[i].classList.remove('active');
        }
        boxpro[slider - 1].classList.add('active');
        number.children[slider - 1].classList.add('active');
      }
    };
  
    // Add 'active' class to the first boxpro and first number
    boxpro[0].classList.add('active');
    number.children[0].classList.add('active');
    prev.classList.add('active');
  
    // Logic for moving slider to the left
    const moveLeft = () => {
      if (slider > 1) {
        slider--;
        sheck();
      }
    };
  
    // Logic for moving slider to the right
    const moveRight = () => {
      if (slider < length) {
        slider++;
        sheck();
      }
    };
  
    // Event listeners for left and right arrow clicks
    prev.addEventListener('click', moveLeft);
    next.addEventListener('click', moveRight);
  
    // Cleanup function to remove event listeners
    return () => {
      prev.removeEventListener('click', moveLeft);
      next.removeEventListener('click', moveRight);
    };
  }, []);
  
  
  
  
  return (
    <>
      <h2 className="page">My Portfolio</h2>
      <div className="portfolio p-10">
        <div className="slider w-10/12 text-white flex items-center justify-between m-auto bg-[#1d1730] rounded-full px-2">
          <GoChevronLeft className="prev" />
          <div className="number flex items-center lg:justify-center xl:justify-center md:justify-center sm:justify-start space-x-2 overflow-x-auto whitespace-nowrap w-full px-2 min-w-0 custom-scrollbar"></div>
          <GoChevronRight className="next" />
        </div>
        <div className="projects proex p-10 bg-gradient-to-r from-[#3b82f652] mx-auto w-10/12 my-10">
          <div className="boxpro active flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={dawood} alt="" />
            <div className="det m-2">
              <h1>Dawood Sweets</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">Welcome to Dawood Sweet! Discover delectable treats, from candies to cakes. Learn about our commitment to quality and customer service. Explore our sweets collection and shop with ease. Contact us for inquiries or feedback. Indulge in sweetness with Dawood Sweet!</p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://elbastawesy122.github.io/Dawood-Sweets/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/Dawood-Sweets"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={progamer} alt="" />
            <div className="det m-2">
              <h1>Pro Gamer</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">Welcome to Pro Gamer! Dive into an array of free-to-play games. Explore their details and dive into the world of gaming. Contact us for inquiries or feedback. Play with passion at Pro Gamer!</p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://progameer.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/Gamer"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={Calculateage} alt="" />
            <div className="det m-2">
              <h1>Calculate Age</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
                Welcome to Calculate Age! Discover a simple and efficient tool to calculate your age instantly. Learn about our commitment to productivity with an integrated to-do list. Explore our features and stay organized with ease. Contact us for inquiries or feedback. Manage your time better with Calculate Age & To-Do List!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://calculate-agee.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/Calculate-Age"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={task1} alt="" />
            <div className="det m-2">
              <h1>Solar Panels</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
              Welcome to Solar Panel Installers In Plymouth! Discover premium solar panels and expert installation services. Learn about our commitment to sustainability and customer satisfaction. Explore our solar solutions and shop with ease. Contact us for inquiries or feedback. Embrace clean energy with Solar Panel Installers In Plymouth!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://taaskone.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/task1"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={vivadecor} alt="" />
            <div className="det m-2">
              <h1>viva decor</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
                Welcome to Viva Decor! Discover stylish and high-quality home furniture. Learn about our commitment to elegance and customer satisfaction. Explore our furniture collection and shop with ease. Contact us for inquiries or feedback. Elevate your home with Viva Decor!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://w2task1.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/w2t1"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={tpdolist} alt="" />
            <div className="det m-2">
              <h1>To-Do List</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
                Welcome to To-Do List! Discover a smart and efficient way to manage your tasks. Learn about our commitment to productivity and user satisfaction. Explore our task management features and stay organized with ease. Contact us for inquiries or feedback. Boost your productivity with TPDoList!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://too-doo-liists.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/w2t2"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={Weather} alt="" />
            <div className="det m-2">
              <h1>Weather APP</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
                Welcome to Weather APP! Discover accurate and real-time weather updates. Learn about our commitment to reliability and user satisfaction. Explore our weather forecasting features and plan your days with ease. Contact us for inquiries or feedback. Stay prepared with Weather APP!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://weeatheerr-app.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/Weather-APP"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={Ecommerce} alt="" />
            <div className="det m-2">
              <h1>E-commerce APP</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
              Welcome to E-Commerce! Discover a seamless online shopping experience with a wide range of products. Learn about our commitment to quality and customer satisfaction. Explore our collection and shop with ease. Contact us for inquiries or feedback. Enjoy convenient shopping with E-Commerce!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://ecoommercee-app.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/E-Commerce-App"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
          <div className="boxpro flex justify-center items-center text-white mx-auto w-fit my-5">
            <img src={islamyat} alt="" />
            <div className="det m-2">
              <h1>ٱسْلَامِيَّات</h1>
              <p className="text-[#715e8b] mx-2 overflow-hidden hover:overflow-auto max-h-44">
                Welcome to Islamiyaat! Discover a comprehensive platform for Quranic recitations by various scholars in different Qira’at. Learn about our commitment to providing authentic Islamic content. Explore our collection of supplications, Tawasheeh, and Hadiths with ease. Contact us for inquiries or feedback. Deepen your faith with Islamiyaat!
              </p>
              <div className="iconpor flex items-center justify-end">
                <a href="https://islamiyaat.netlify.app/"><MdOutlineVisibility /></a>
                <a href="https://github.com/Elbastawesy122/Quran-Player"><IoLogoGithub /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Portfolio;
